import React, { useEffect, useState } from 'react'
import { Box, Button, List } from '@mui/material'
import { toast } from 'react-toastify'
import { getObjects, editObject, deleteObject } from '../../../api/apiClientCrud'
import { useAuth } from '../../../context/AuthContext'
import ListEmails from './ListEmails'
import ListMailBoxFolders from './ListMailBoxFolders'
import EmailToolbar from './EmailToolbar'
import EmailContent from './EmailContent'
import EmailDialog from '../../dialogs/EmailDialog'
import { MdInbox, MdDrafts, MdPresentToAll } from 'react-icons/md'
import { RiSpam2Line } from 'react-icons/ri'
import { TbTrash } from 'react-icons/tb'
import { Buffer } from 'buffer'
import { saveAs } from 'file-saver'

const MailBox = () => {
  const [emails, setEmails] = useState([])
  const [selected, setSelected] = useState(0)
  const [selectedBoxId, setSelectedBoxId] = useState(1)
  const [selectedBox, setSelectedBox] = useState('INBOX')
  const [selectedItem, setSelectedItem] = useState({})
  const [isAnswer, setIsAnwser] = useState(false)
  const [isAnswerAll, setIsAnwserAll] = useState(false)
  const [isFroward, setIsForward] = useState(false)
  const [newEmail, setNewEmail] = useState(false)
  const [page, pagechange] = useState(0)
  const rowperpage = 5
  const [totalItem, setTotalItem] = useState(0)
  const [isUpdated, setIsUpdated] = useState(false)
  const [open, setOpen] = useState(false)
  const [emailDraft, setEmailDraft] = useState({})
  const [config, setConfig] = useState(null)
  const { user } = useAuth()

  const mailBoxes = [
    { id: 1, name: 'INBOX', displayname: 'Boîte de réception', icon: () => <MdInbox size='24px' /> },
    { id: 2, name: 'DRAFT', displayname: 'Brouillons', icon: () => <MdDrafts size='24px' /> },
    { id: 3, name: 'SENT', displayname: 'Envoyés', icon: () => <MdPresentToAll size='24px' /> },
    { id: 4, name: 'SPAM', displayname: 'Spam', icon: () => <RiSpam2Line size='24px' /> },
    { id: 5, name: 'TRASH', displayname: 'Corbeille', icon: () => <TbTrash size='24px' /> }
  ]

  const handleListBoxClick = (name, id) => {
    setSelectedBox(name)
    setSelectedBoxId(id)
    setSelected(0)
    pagechange(0)
    setNewEmail(false)
    setIsAnwser(false)
    setIsAnwserAll(false)
    setIsForward(false)
  }

  const newEmailFunction = () => {
    setNewEmail(true)
    setIsAnwser(false)
    setIsAnwserAll(false)
    setIsForward(false)
    setConfig({ autofocus: false, placeholder: '' })
    setEmailDraft({ fromEmail: '', subject: null, ccEmail: null, toEmail: null })
    setOpen(true)
  }

  const handleListItemClick = async (id) => {
    setSelected(id)
    const elemIndex = emails.findIndex((e) => e.id === id)
    if (elemIndex >= 0 && emails[elemIndex].isUnread) {
      try {
        await editObject('email', id, { isUnread: 0, lastModBy: user.email })
        emails[elemIndex].isUnread = 0
        setEmails([...emails])
      } catch {}
    }
    setNewEmail(false)
    setIsAnwser(false)
    setIsAnwserAll(false)
    setIsForward(false)
  }

  const deleteEmail = async (id) => {
    const elemIndex = emails.findIndex((e) => e.id === id)
    if (elemIndex < 0) return
    const email = emails[elemIndex]

    if (email.folder === 'TRASH') {
      try {
        await deleteObject('email', id)
        emails.splice(elemIndex, 1)
        setEmails([...emails])
        setIsUpdated(true)
        setSelected(0)
      } catch {}
    } else {
      try {
        await editObject('email', id, { folder: 'TRASH', lastModBy: user.email })
        emails[elemIndex].folder = 'TRASH'
        setEmails([...emails])
        setIsUpdated(true)
        setSelected(0)
      } catch {}
    }
  }

  const getRequestParams = (page, rowperpage, mailbox, folder) => {
    const params = {}
    if (page) params.page = page
    if (rowperpage) params.size = rowperpage
    if (folder) params.folder = folder
    if (mailbox) params.mailbox = mailbox
    return params
  }

  const downladfile = (index) => {
    const file = selectedItem.attachments[index].file
    const buffer = Buffer.from(file)
    const blob = new Blob([buffer])
    saveAs(blob, selectedItem.attachments[index].filename)
  }

  const OpenDialog = () => setOpen(true)

  const answerEmail = () => {
    setIsAnwser(true)
    setIsAnwserAll(false)
    setIsForward(false)
    setNewEmail(false)
    setConfig({ autofocus: true, cursorAfterAutofocus: 'start' })
    setEmailDraft({
      ...selectedItem,
      fromEmail: user.email,
      toEmail: [selectedItem.fromEmail],
      subject: 'Re: ' + selectedItem.subject,
      html: `<p></p><blockquote type="cite"><div>Le ${selectedItem.datetime}, ${selectedItem.fromName} &lt;${selectedItem.fromEmail}&gt; a écrit :</div><br>${selectedItem.html}</blockquote>`
    })
    OpenDialog()
  }

  const answerEmailAll = () => {
    setIsAnwser(false)
    setIsAnwserAll(true)
    setIsForward(false)
    setNewEmail(false)
    setConfig({ autofocus: true, cursorAfterAutofocus: 'start' })
    setEmailDraft({
      ...selectedItem,
      fromEmail: user.email,
      toEmail: [...new Set([selectedItem.fromEmail].concat(selectedItem.toEmail.split(';')))],
      ccEmail: selectedItem.ccEmail ? selectedItem.ccEmail.split(';') : null,
      subject: 'Re: ' + selectedItem.subject,
      html: `<p></p><blockquote type="cite"><div>Le ${selectedItem.datetime}, ${selectedItem.fromName} &lt;${selectedItem.fromEmail}&gt; a écrit :</div><br>${selectedItem.html}</blockquote>`
    })
    OpenDialog()
  }

  const forwardEmail = () => {
    setIsAnwser(false)
    setIsAnwserAll(false)
    setIsForward(true)
    setNewEmail(false)
    setConfig({ autofocus: false })
    setEmailDraft({
      ...selectedItem,
      fromEmail: user.email,
      subject: 'Fwd: ' + selectedItem.subject,
      toEmail: null,
      html: `<p></p><blockquote type="cite"><p>---------- Forwarded message ---------</p>
        <p>De : ${selectedItem.fromEmail}</p>
        <p>Date : ${selectedItem.datetime}</p>
        <p>Sujet : ${selectedItem.subject}</p>
        <p>To : ${selectedItem.toEmail}</p>${selectedItem.html}</blockquote>`
    })
    OpenDialog()
  }

  const editEmail = () => {
    setEmailDraft({
      ...selectedItem,
      toEmail: selectedItem.toEmail ? selectedItem.toEmail.split(';') : null,
      ccEmail: selectedItem.ccEmail ? selectedItem.ccEmail.split(';') : null,
      cciEmail: selectedItem.cciEmail ? selectedItem.cciEmail.split(';') : null
    })
    OpenDialog()
  }

  const handlechangepage = (_, newpage) => pagechange(newpage)

  useEffect(() => {
    const elem = emails.find((e) => e.id === selected)
    setSelectedItem(elem)
  }, [selected, emails])

  useEffect(() => {
    const fetchEmails = async () => {
      try {
        const res = await getObjects('email', getRequestParams(page, rowperpage, user.email, selectedBox))
        setEmails(res.data.emails)
        setTotalItem(res.data.totalItems)
      } catch {
        toast.error('Erreur lors du chargement', { autoClose: 2000 })
      }
    }
    setIsUpdated(false)
    fetchEmails()
  }, [rowperpage, page, selectedBox, isUpdated, user.email])

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', height: 'calc(100vh - 65px)', overflowY: 'auto', flexGrow: 1 }}>
      <Box sx={{ display: 'flex', width: '15%', flexDirection: 'column' }}>
        <Button sx={{ marginTop: '10px' }} color='primary' onClick={newEmailFunction}>
          Nouveau Courriel
        </Button>
        <List sx={{ bgcolor: 'background.paper' }}>
          {mailBoxes.map((item) => (
            <ListMailBoxFolders
              key={item.id}
              item={item}
              selectedItem={selectedBoxId}
              onClick={(name, id) => handleListBoxClick(name, id)}
            />
          ))}
        </List>
      </Box>

      <Box sx={{ display: 'flex', width: '35%', flexDirection: 'column', height: '100%' }}>
        <ListEmails
          emails={emails}
          onPageChange={handlechangepage}
          onSelect={handleListItemClick}
          page={page}
          rowsPerPage={rowperpage}
          selected={selected}
          totalItem={totalItem}
        />
      </Box>

      <Box sx={{ display: 'flex', width: '50%', flexDirection: 'column' }}>
        <EmailToolbar
          selectedItem={selectedItem}
          selectedBox={selectedBox}
          onReply={answerEmail}
          onReplyAll={answerEmailAll}
          onForward={forwardEmail}
          onDelete={() => deleteEmail(selectedItem?.id)}
          onEdit={editEmail}
        />
        <Box sx={{ display: 'flex', flexDirection: 'row', height: '90%', width: '100%' }}>
          <EmailContent selectedItem={selectedItem} downladfile={downladfile} />
        </Box>
        <EmailDialog
          open={open}
          emails={emails}
          selected={selected}
          setEmails={setEmails}
          setSelected={setSelected}
          setIsUpdated={setIsUpdated}
          isAnswer={isAnswer}
          isAnswerAll={isAnswerAll}
          isFroward={isFroward}
          isNewEmail={newEmail}
          config={config}
          email={emailDraft}
          setOpen={setOpen}
          isSent={setIsAnwser}
        />
      </Box>
    </Box>
  )
}

export default MailBox
